import { AES, enc } from "crypto-js";
import { encryptionkey } from "../environment";

// The gateway wraps JSON bodies as { encrypted: true, payload: "<ciphertext>" }.
// Anything else (blobs, downloads, plain JSON) is left alone.
export const isEncryptedEnvelope = (body) =>
  !!body && body.encrypted === true && typeof body.payload === "string";

export const decryptEnvelope = (body) => {
  // Create React App inlines env vars when the dev server BOOTS - editing .env
  // and hot-reloading leaves the old (often empty) value in the bundle, so call
  // this case out by name instead of reporting a generic key mismatch.
  if (!encryptionkey) {
    throw new Error(
      "Encrypted API response received but REACT_APP_*_ENCRYPTION_KEY is empty. " +
        "If you just added it to .env, restart the dev server - CRA only reads .env at startup."
    );
  }

  let plainText;

  try {
    // On a key mismatch crypto-js throws "Malformed UTF-8 data" instead of
    // returning an empty string, so both failure modes are funnelled here.
    plainText = AES.decrypt(body.payload, encryptionkey).toString(enc.Utf8);
  } catch (e) {
    plainText = "";
  }

  if (!plainText) {
    throw new Error(
      "Failed to decrypt API response - REACT_APP_*_ENCRYPTION_KEY does not match the gateway key"
    );
  }

  try {
    return JSON.parse(plainText);
  } catch (e) {
    return plainText;
  }
};

// Attach before the app's own response interceptors so they keep seeing a
// plain object. Error bodies are encrypted too, hence the rejection handler.
export const attachDecryptInterceptor = (instance) =>
  instance.interceptors.response.use(
    (response) => {
      if (isEncryptedEnvelope(response?.data)) {
        response.data = decryptEnvelope(response.data);
      }
      return response;
    },
    (error) => {
      if (isEncryptedEnvelope(error?.response?.data)) {
        error.response.data = decryptEnvelope(error.response.data);
      }
      return Promise.reject(error);
    }
  );
